import type {
    AddDonationRequestBody,
    AddItemRequestBody,
    CartUI,
    CartCreateBody,
    RemoveItemRequestBody,
    UpdateItemQtyRequestBody,
    PickupInfoRequestBody,
    AddBillingAddressRequestBody,
    ApplyPromoCodeRequestBody,
    AddPaymentMethodRequestBody,
    PlaceOrderRequestBody,
    UpdateItemFulfillmentMethodRequestBody,
    TreatPointRequestBody,
    SetShippingMethodRequestBody,
    AddPrescriptionBody,
    DeliveryOptionsPost,
} from '@libs/common-node';
import {
    AUTH_COOKIES,
    AUTH_HEADERS,
    COOKIES,
    type HttpMethod,
} from '@libs/core';
import Cookie from 'js-cookie';
import { typedFetch } from './typedFetch';
import { extractCustomerKeyFromAccessToken } from './extractCustomerKeyFromAccessToken';

export const getHeaders = () => {
    const headers: HeadersInit = {};
    // get header values
    const token = Cookie.get(AUTH_COOKIES.ACCESS_TOKEN);
    const anonymousKey = Cookie.get(AUTH_COOKIES.PETM_ANONYMOUS_KEY);
    const customerKey = Cookie.get(AUTH_COOKIES.PETM_CUSTOMER_KEY);
    const cartId = Cookie.get(COOKIES.CART_ID);

    if (token) {
        headers[AUTH_HEADERS.AUTHORIZATION] = `Bearer ${token}`;

        const customerKey = extractCustomerKeyFromAccessToken(token);

        if (customerKey) {
            headers[AUTH_HEADERS.X_PETM_CUSTOMER_KEY] = customerKey;
        }
    }

    if (cartId) {
        headers[AUTH_HEADERS.X_PETM_CART_ID] = cartId;
    }

    // this is a check if there are both cookies (customerKey > anonymousKey)
    if (anonymousKey && !customerKey) {
        headers[AUTH_HEADERS.X_PETM_ANONYMOUS_KEY] = anonymousKey;
    }

    if (customerKey) {
        headers[AUTH_HEADERS.X_PETM_CUSTOMER_KEY] = customerKey;
    }

    return headers;
};

const fetchCart = async <T = CartUI | null>(
    url: string,
    method: HttpMethod,
    body?:
        | CartCreateBody
        | AddItemRequestBody
        | UpdateItemQtyRequestBody
        | UpdateItemFulfillmentMethodRequestBody
        | RemoveItemRequestBody
        | AddDonationRequestBody
        | PickupInfoRequestBody
        | AddBillingAddressRequestBody
        | ApplyPromoCodeRequestBody
        | AddPaymentMethodRequestBody
        | PlaceOrderRequestBody
        | SetShippingMethodRequestBody
        | TreatPointRequestBody
        | AddPrescriptionBody
        | DeliveryOptionsPost,
    additionalHeaders?: { [key: string]: string },
    additionalSuccessCodes: number[] = [303, 400]
): Promise<T | null> =>
    typedFetch<T | null>(url, {
        method,
        body: body ? JSON.stringify(body) : undefined,
        headers: {
            ...getHeaders(),
            ...additionalHeaders,
        },
        additionalSuccessCodes,
    });

export default fetchCart;
